import { HTTP } from "./../api/http-common";
import React, { useState, useEffect } from "react";
import { Copy } from "lucide-react";
import { Link } from "react-router-dom";
import { Eye, EyeOff } from "lucide-react";
import { useGlobalContext } from "./../component/GlobalContext";
import Tippy from '@tippyjs/react';
import 'tippy.js/dist/tippy.css';
const CouponCard = ({ coupon, couponSize }) => {
  const { globalUserVar, isAuthenticated, setIsAuthenticated, isActiveMember } = useGlobalContext();
  const [firstName, setFirstName] = useState("");
  const [role, setRole] = useState("");
  const [couponShow, setCouponShow] = useState(false);
  const [timer, setTimer] = useState(null);
  const [remainingSeconds, setRemainingSeconds] = useState(0);
  const [copySuccess, setCopySuccess] = useState("");
  const [hoverTitle, setHoverTitle] = useState("Click Here to Get the Deal!");

  // Function to record coupon usage in the backend
  const recordCouponUsage = async () => {
    try {
      const access_token = localStorage.getItem("access_token");
      let config = {
        headers: { "Content-Type": "application/json", token: access_token },
      };
      let formData = {
        coupon_id: coupon.id,
      };

      await HTTP.post("/coupon/couponusage", formData, config)
        .then((response) => {
          if (response.status === 200) {
            console.log(response.data.message)
          }
        })
        .catch((error) => {
          console.log(error.response.data.detail)
        });
    } catch (error) {
      console.error("Error recording coupon usage", error);
    }
  };

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(coupon.coupon_code);
      setCopySuccess("Copied to clipboard!");
    } catch (error) {
      setCopySuccess("Failed to copy!");
    }

    // Clear success message after a few seconds
    setTimeout(() => setCopySuccess(""), 2000);
  };

  const hideShowCoupon = () => {
    if (!couponShow) {
      setCouponShow(true);
      setRemainingSeconds(30); // Start countdown from 30 seconds

      // Update the countdown every second
      const interval = setInterval(() => {
        setRemainingSeconds((prev) => {
          if (prev === 1) {
            // Stop the countdown and hide the coupon when it reaches 0
            clearInterval(interval);
            setCouponShow(false);
            return 0;
          }
          return prev - 1;
        });
      }, 1000);

      // Store the timer reference to clear it later
      setTimer(interval);
    }
  };

  const truncateText = (text, limit) => {
    return text.length > limit ? `${text.substring(0, limit)}...` : text;
  };


  useEffect(() => {
    if (isAuthenticated) {
      let userObj = localStorage.getItem('userObj');
      if (userObj != null && userObj !== "") {
        let userJson = JSON.parse(userObj);
        setFirstName(userJson.first_name);
        setRole(userJson.role.name);
      }
    }
  }, [isAuthenticated]);

  return (

    // className={`bg-white shadow-[0px_4px_10px_#00000026] p-3 rounded-3xl h-full w-full max-w-[580px] h-[200px]${couponSize}`}
    <div className={`bg-white vendor-sub-section-structure p-3 rounded-3xl vendor-sub-section-structure w-full max-w-[580px] custom-coupon-size ${couponSize}`}>
      <div className="coupon-wrapper flex h-full lg:flex-row flex-col-reverse">
        <div className="xl:w-9/12 w-full coupon-details-left">
          <div className="coupon-description-section">
            <p className=" border-b-2  inline-block border-dashed border-[#EDE8F9] text-[18px] w-full pb-1.5 lg:py-2">{coupon.business_name == null ? 'Business name ' : coupon.business_name}</p>
            <div className="coupon-value">
            {coupon.coupon_type == "1" ? (
              <h3 className="text-[20px] font-extrabold md:pt-4 pt-2 coupon-price-info">$ {coupon.coupon_value} OFF</h3>
            ) : coupon.coupon_type == "2" ? (
              <h3 className="text-[20px] font-extrabold md:pt-4 pt-2 "> {coupon.coupon_value} % OFF </h3>
            ) : (
              <span>No Coupon Applied</span>
            )}
              
            </div>

            {/* <div className=""> <p className="text-sm py-2">
              {coupon.description}
            </p></div> */}

            <div className="">
              {coupon.description.length > 70 ? (
                <Tippy content={coupon.description} placement="top">
                  <p className="text-sm md:py-2 py-0">
                    {truncateText(coupon.description, 70)}
                  </p>
                </Tippy>
              ) : (
                <p className="text-sm  xl:py-2">{coupon.description}</p>
              )}
            </div>

            <div className=" ">

              <span className="text-[13px] border-b inline-block pb-1">
                Valid Until <b>{coupon.converted_expiration_date}</b>
              </span>
            </div>
          </div>
        </div>
        <div className="xl:w-3/12 w-full coupon-card-logo-right relative vendor-coupon-border md:px-2.5 md:pt-2 p-0">
          {/* <div className="absolute border-r-2 border-dashed border-[#EDE8F9] h-[calc(8rem-20px)]"></div> */}
          <div className="flex h-full flex-col justify-evenly items-center">
            <div className="">
              <div className="mb-1.5 lg:mb-3 vendor-coupon-image-wrapper" >
                <Link to={`/vendor/details/${coupon.vendor_id}`}>
                  <img
                    src={coupon.vendor_banner_image}
                    alt="Business logo"
                    className="rounded-[50%] w-[75px] h-[75px]"
                  />
                </Link>
              </div>
            </div>
            <div className="">
              {(isAuthenticated && isActiveMember) ? (
                <div className="">

                  <div className="flex items-center justify-between gap-2 bg-[#F4F1FF] px-[4px] py-[6px] rounded-lg visible-coupon-code-size">
                    {couponShow ? (
                      <span className="text-sm font-medium leading-[16.41px] text-[#6C1CFF]">
                        {coupon.coupon_code}
                      </span>
                    ) : (
                      <Tippy content={hoverTitle} placement="top">
                        <span className="text-sm font-medium leading-[16.41px] text-[#6C1CFF]">
                          -----
                        </span>
                      </Tippy>
                      
                    )}
                    {couponShow ? null : (
                      <Tippy content={hoverTitle} placement="top">
                        <EyeOff
                          className="lucide lucide-copy h-4 w-4 text-primary"
                          
                          onClick={async () => {
                            hideShowCoupon();
                            await recordCouponUsage();
                          }}
                        />
                        </Tippy>
                      
                    )}
                  </div>
                  {/* 6px 4px */}
                    {couponShow && remainingSeconds > 0 && (
                  <span className="text-xs text-gray-500 block mt-2 w-full text-center">

                      <span className="">
                        Visible for {remainingSeconds} seconds
                      </span>
                  </span>
                    )}
                </div>
              ) : (
                <Link to={`/subscription/member`}>
                  <div className="flex items-center justify-between gap-2 bg-[#F4F1FF] px-4 py-1.5 rounded-lg">
                      
                      <span className="text-sm font-medium leading-[16.41px] text-[#6C1CFF]" title={hoverTitle}>
                        -----
                      </span>
                      <Tippy content={hoverTitle} placement="top">
                        <EyeOff className="lucide lucide-copy h-4 w-4 text-primary"/>
                      </Tippy>
                  </div>
                </Link>
              )}
            </div>
          </div>
          {/* section B */}
        </div>

        {/* <div className=""></div> */}
      </div>
    </div>
  );
};

export default CouponCard;
